import React from "react";
import Receipt from "../Receipt";

const ServiceReceipt = ({show, onHide, receipt}) => {
  return (
    <Receipt
      // toPrint
      receipt={receipt}
    />
  )
}

export default ServiceReceipt;